import { useState } from 'react'
import clsx from 'clsx'
import { CheckCircle2, Clock, FolderTree, Loader2 } from 'lucide-react'
import { useUpdateMdmPolicy, useInheritMdmPolicy } from '../../../hooks/useMdm'
import PolicyForm from './PolicyForm'
import { errorMessage, policySourceLabel } from './mobileUtils'

/**
 * Política do tablet. Por padrão ele segue a do grupo (CONTRACT.md §11); salvar aqui cria uma
 * política própria, e "Voltar a seguir o grupo" descarta a própria.
 */
export default function PoliciesTab({ deviceId, state, readOnly }) {
  const save = useUpdateMdmPolicy(deviceId)
  const inherit = useInheritMdmPolicy(deviceId)
  const [inheritMsg, setInheritMsg] = useState(null)

  const applied = state?.policyVersion != null && state?.appliedPolicyVersion === state?.policyVersion

  const handleSave = async (body) => {
    const res = await save.mutateAsync(body)
    return `Política própria do tablet salva (versão ${res?.policyVersion ?? '?'}) e enviada.`
  }

  const handleInherit = async () => {
    setInheritMsg(null)
    try {
      await inherit.mutateAsync()
      setInheritMsg({ ok: true, text: 'O tablet voltou a seguir a política do grupo.' })
    } catch (e) {
      setInheritMsg({ ok: false, text: errorMessage(e, 'Não foi possível voltar à política do grupo.') })
    }
  }

  return (
    <div className="space-y-4">
      <div className={clsx('flex flex-wrap items-center gap-2 px-3 py-2 rounded-lg border text-sm',
        state?.policyInherited ? 'bg-gray-50 border-gray-200 text-gray-700' : 'bg-amber-50 border-amber-200 text-amber-900')}>
        <FolderTree className="w-4 h-4 flex-shrink-0" />
        {state?.policyInherited ? (
          <span>Segue a política {policySourceLabel(state)}. Salvar alterações aqui cria uma política própria só deste tablet.</span>
        ) : (
          <>
            <span>Política própria deste tablet — mudanças na política do grupo não chegam aqui.</span>
            {!readOnly && (
              <button
                type="button"
                onClick={handleInherit}
                disabled={inherit.isPending}
                className="ml-auto flex items-center gap-1 px-2.5 py-1 text-xs border border-amber-300 bg-white rounded-md hover:bg-amber-100 disabled:opacity-50"
              >
                {inherit.isPending && <Loader2 className="w-3 h-3 animate-spin" />}
                Voltar a seguir o grupo
              </button>
            )}
          </>
        )}
      </div>
      {inheritMsg && <p className={clsx('text-sm', inheritMsg.ok ? 'text-green-700' : 'text-red-600')}>{inheritMsg.text}</p>}

      <PolicyForm
        policy={state?.policy}
        reloadKey={state?.policyVersion}
        readOnly={readOnly}
        saving={save.isPending}
        onSave={handleSave}
        toolbar={(
          <span className={clsx('inline-flex items-center gap-1 text-sm', applied ? 'text-green-700' : 'text-amber-700')}>
            {applied ? <CheckCircle2 className="w-4 h-4" /> : <Clock className="w-4 h-4" />}
            Versão {state?.policyVersion ?? '—'} · aplicada no tablet: {state?.appliedPolicyVersion ?? '—'}
          </span>
        )}
      />
    </div>
  )
}
